import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/discounts', request)
}

export {get}
